import { ProgressBarColor } from "../../progress-bar";
export const getSuccessfulUploadCount = (files) => {
    let count = 0;
    for (let i = 0; i < files.length; i++) {
        if (files[i].isDone && !files[i].isUploadFailed) {
            count++;
        }
    }
    return count;
};
export const getFailedUploadCount = (files) => {
    let count = 0;
    for (let i = 0; i < files.length; i++) {
        if (files[i].isUploadFailed) {
            count++;
        }
    }
    return count;
};
export const getIsDoneCount = (files) => {
    let count = 0;
    for (let i = 0; i < files.length; i++) {
        if (files[i].isDone) {
            count++;
        }
    }
    return count;
};
export const isAllDone = (files) => {
    for (let i = 0; i < files.length; i++) {
        if (!files[i].isDone) {
            return false;
        }
    }
    return true;
};
export const getProgressColor = (isUploadFailed, successProgressBarColor) => {
    return isUploadFailed ? ProgressBarColor.RED : successProgressBarColor || ProgressBarColor.BLUE;
};
export const getProgress = (isDone, progress) => {
    if (isDone) {
        return 100;
    }
    return progress ? progress : 0;
};
export const getFileUploadProgress = (successCount, filesLength) => {
    if (filesLength === 0) {
        return 100;
    }
    return Math.floor((successCount / filesLength) * 100);
};
export function isThumbnailImageEqual(thumbnail1, thumbnail2) {
    return (!thumbnail1 && !thumbnail2) || (!!thumbnail1 && !!thumbnail2);
}
export const isFileUploadStatusEqual = (status1, status2) => {
    return (status1 === null || status1 === void 0 ? void 0 : status1.message) === (status2 === null || status2 === void 0 ? void 0 : status2.message) && (status1 === null || status1 === void 0 ? void 0 : status1.type) === (status2 === null || status2 === void 0 ? void 0 : status2.type);
};
export const isFileDataEqual = (file1, file2) => {
    return (file1.progress === file2.progress &&
        file1.isUploadFailed === file2.isUploadFailed &&
        file1.fileSize === file2.fileSize &&
        file1.isDone === file2.isDone &&
        isFileUploadStatusEqual(file1.status, file2.status) &&
        isThumbnailImageEqual(file1.thumbnailImage, file2.thumbnailImage));
};
//# sourceMappingURL=FileUploadModalOperations.js.map